/* eslint-disable max-lines */
import { editLanguageMatcher } from 'actions/identifier';
import WarningMsg from 'components/WarningMsg';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  getCompareMode,
  getShouldDisableEdit,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import { languageMatcherNotificationMsgs } from 'utils/userNotificationMsgs';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';

type Props = { isSaved: boolean };

const MetadataLengthForm: React.FC<Props> = ({ isSaved }) => {
  const dispatch = useDispatch();
  const unsaved = useSelector(unsavedChanges);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  const compareMode = useSelector(getCompareMode);
  const shouldDisable = useSelector(getShouldDisableEdit);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);

  const onEditLanguageMatcher = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!activeLanguageMatcher.uuid || e.target.value === null) return;
    dispatch(
      editLanguageMatcher({
        languageMatcherId: activeLanguageMatcher.uuid,
        data: { [e.target.name]: e.target.value },
      })
    );
  };

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={languageMatcherNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>

      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader />

        <div className="mt-6 flex flex-col gap-2">
          <span className="text-body">Annotate document with characters</span>
          <div className="flex flex-row gap-4">
            <div className="flex flex-col gap-1 w-62">
              <span className="text-body">More than</span>
              <input
                name="min_length"
                id="min_length"
                type="number"
                data-testid="metadata-min-length-input"
                // @ts-ignore
                value={activeLanguageMatcher.min_length ?? ''}
                onChange={onEditLanguageMatcher}
                className="form-input w-full h-9 py-2 px-4 border border-litlingo-gray-2 rounded-lg text-body focus:outline-none"
                disabled={compareMode || shouldDisable}
              />
            </div>

            <div className="flex flex-col gap-1 w-60">
              <span className="text-body">Less than</span>
              <input
                name="max_length"
                id="max_length"
                type="number"
                data-testid="metadata-max-length-input"
                // @ts-ignore
                value={activeLanguageMatcher.max_length ?? ''}
                onChange={onEditLanguageMatcher}
                className="form-input w-full h-9 py-2 px-4 border border-litlingo-gray-2 rounded-lg text-body focus:outline-none"
                disabled={compareMode || shouldDisable}
              />
            </div>
          </div>
        </div>

        <div className="mt-auto pt-6 flex flex-row justify-end">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
        <div className="hidden" data-testid="metadata-length-language-matcher-id">
          {activeLanguageMatcherId}
        </div>
      </div>
    </div>
  );
};

export default MetadataLengthForm;
